/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const reportRoutes = [
  {
    path: "inspection-reports",
    canActivateChild: [
      isLoggedIn,
      hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce),
    ],
    children: [
      {
        path: ":inspectionId",
        children: [
          {
            path: "",
            loadComponent: () => import("./inspection-report/inspection-report-form").then(m => m.InspectionReportForm),
          },
          // Images
          {
            path: "images",
            children: [
              {
                path: "global",
                children: [
                  {
                    path: "create",
                    loadComponent: () => import("./images/global/creation-form/global-image-creation-form").then(m => m.GlobalImageCreationForm),
                  },
                ],
              },
              {
                path: "diagram",
                children: [
                  {
                    path: "create",
                    loadComponent: () => import("./images/diagram/creation-form/diagram-image-creation-form").then(m => m.DiagramImageCreationForm),
                  },
                ],
              },
            ],
          },
          // Defects
          {
            path: "defects",
            children: [
              {
                path: "create",
                loadComponent: () => import("./defects/form/defect-form").then(m => m.DefectForm),
              },
              {
                path: ":defectId",
                children: [
                  {
                    path: "",
                    loadComponent: () => import("./defects/form/defect-form").then(m => m.DefectForm),
                  },
                  {
                    path: "images",
                    children: [
                      {
                        path: "create",
                        loadComponent: () => import("./images/defect/creation-form/defect-image-creation-form").then(m => m.DefectImageCreationForm),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
] as const satisfies Routes;
